/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ImageVersionTypeName = "large" | "master" | "medium" | "original" | "placeholder" | "small" | "thumb" | "zoom" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpHead_item$ref: FragmentReference;
export type PdpHead_item = {|
  +microdata: ?string,
  +pdpURL: ?string,
  +localizedPdpUrl: ?string,
  +pdpMeta: ?{|
    +title: ?string,
    +description: ?string,
    +ogTitle: ?string,
    +productPriceAmount: ?string,
    +productPriceCurrency: ?string,
  |},
  +photos: ?$ReadOnlyArray<?{|
    +versions: ?$ReadOnlyArray<?{|
      +webPath: ?string,
      +type: ?{|
        +name: ?ImageVersionTypeName
      |},
    |}>
  |}>,
  +isListingNotListed: ?boolean,
  +isMissingTranslatedItemTitle: ?boolean,
  +seller: ?{|
    +isInternal: ?boolean
  |},
  +isSold: ?boolean,
  +metrics: ?$ReadOnlyArray<?{|
    +value: ?string
  |}>,
  +$refType: PdpHead_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpHead_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "forcedCurrency",
      "type": "Currency"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "microdata",
      "args": [
        {
          "kind": "Variable",
          "name": "currency",
          "variableName": "forcedCurrency",
          "type": "Currency"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pdpURL",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localizedPdpUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pdpMeta",
      "storageKey": null,
      "args": null,
      "concreteType": "pdpMetaItems",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "ogTitle",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "productPriceAmount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "productPriceCurrency",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "versions",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "webPath",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "type",
              "storageKey": null,
              "args": null,
              "concreteType": "ImageVersionType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isListingNotListed",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isMissingTranslatedItemTitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isInternal",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isSold",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "metrics",
      "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")",
      "args": [
        {
          "kind": "Literal",
          "name": "metricTypes",
          "value": [
            "LISTING_VIEWS"
          ],
          "type": "[MetricType]!"
        },
        {
          "kind": "Literal",
          "name": "timeRange",
          "value": "LAST_6_MONTHS",
          "type": "MetricsTimeRangeEnum!"
        }
      ],
      "concreteType": "MetricDetailType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6f2b3c49162fa8016808a78cab3c3183';
module.exports = node;
